import React from 'react';
/* eslint-disable */
export function CheckCircleOutlined(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.3334 9.23333V10C18.3324 11.797 17.7505 13.5456 16.6745 14.9849C15.5986 16.4241 14.0862 17.4771 12.3629 17.9866C10.6396 18.4961 8.7978 18.4349 7.11214 17.8122C5.42648 17.1894 3.98729 16.0384 3.00922 14.5309C2.03114 13.0234 1.56657 11.2401 1.68481 9.44693C1.80305 7.6538 2.49775 5.94694 3.66531 4.58089C4.83288 3.21485 6.41074 2.26282 8.16357 1.86679C9.91641 1.47076 11.7503 1.65195 13.3918 2.38333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 3.33334L10 11.675L7.5 9.17501"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
